<template>
    <div>
    </div>
</template>

<script>
    import {Trans} from '@/plugins/Translation'
    import BaseVue from '../views/BaseVue'
    import {EventBus} from '../util/event-bus.js'
    import Analytics from '../util/analytics'

    export default {
        name: 'BaseRace',
        extends: BaseVue,
        async beforeRouteUpdate(to,from,next) {
            this.loaded = false
            this.id = to.params.id
            let data = await this.get(this.id + '/light', true)
            this.data = data.RaceDetails
            this.loaded = true
            await this.$nextTick()
            if (this.hasResults)
                EventBus.$emit('classifica', true)
            next()
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                classifiche: [],
                data: null,
                loaded: false,
                id: null,
                downloadClassForm: {
                    action: '',
                    filename: ''
                }
            }
        }, async mounted() {
            this.id = this.$route.params.id
            let data = await this.get(this.id + '/light', true)
            this.data = data.RaceDetails
            this.loaded = true
            this.getInfoIscrizioni()
            await this.$nextTick()
            if (this.hasResults)
                EventBus.$emit('classifica', true)
        }, methods: {
            async getInfoIscrizioni() {
                this.sub = await this.getEnow('/race/subscription/' + this.data.ID)
            }, async getBanner() {
                let data = await this.get([
                    this.id + '/ads/web.race',
                    // this.id + '/ads/web.top'
                ])
                this.banner.race = data[0].BannerList
                // this.banner.top = data[1].BannerList

            }
        }, computed: {
            isPica() {
                if (!this.data || !this.data.Services)
                    return false

                return (this.data.Services.PhotoUrl === 'https://www.getpica.com')
            }, currentLanguage() {
                return Trans.currentLanguage
            }, hasResults() {
                if (this.data === null) return false
                if (this.data.Services.ResultUrl) return false

                // Se sono admin ed è disponibile, mostrarlo sempre
                if (this.admin && this.isAvailable(this.data.Services.Result)) return true                

                if (this.isAvailableForFuture(this.data.Services.Result)) return false
                if (this.isToday(this.data.Services.Result)) return false
                return this.isActive(this.data.Services.Result)
            }, maps() {
                if (!this.loaded) return false
                if (this.data.Events.length <= 0) return false

                let ev = this.data.Events[0]
                return {
                    lat: ev.MapLatitude,
                    lon: ev.MapLongitude
                }
            }, url_gmaps() {
                if (!this.maps) return ''
                return 'http://maps.apple.com/?ll=' + this.maps.lat + ',' + this.maps.lon
            }
        }
    }

</script>

<style scoped>

</style>
